module.exports = __webpack_public_path__ + "assets/img/tu-2.0a4a6b99.png";